<template>
  <div class="bg-transparent rounded-2px z-99 w-full h-full pt-10px relative">
    <div class="h-20/100">
      <div class="w-full">
        <CategoryTitle title="安防设备"></CategoryTitle>
        <div class="statisticsRate flex justify-between mt-10px">
          <div
            v-for="(item, index) in rateList"
            :key="index"
            class="w-31/100 flex flex-col justify-center reteItem cursor-pointer"
            @click="checkCameraList(item.name)"
          >
            <div :class="index === 0 ? 'one' : index === 1 ? 'two' : 'three'">{{ item.name }}</div>
            <div class="bottomBox">
              <div class="flex justify-between items-center h-28px p-8px totalBox">
                <span class="text-12px withe07">总数</span>
                <span>{{ item.totalNum }}</span>
              </div>
              <div class="onLine flex justify-between items-center mt-10px">
                <div class="flex justify-start items-center">
                  <div class="onlineCircle"></div>
                  <span class="text-12px withe07 ml-5px">在线</span>
                </div>
                <div class="text-12px">{{ item.onlineNum }}</div>
              </div>
              <div class="offLine flex justify-between items-center mt-5px">
                <div class="flex justify-start items-center">
                  <div class="offlineCircle"></div>
                  <span class="text-12px withe07 ml-5px">离线</span>
                </div>
                <div class="text-12px">{{ item.offLineNum }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
    <div class="w-full h-25/100 mt-5px">
      <div class="flex justify-between items-center">
        <CategoryTitle title="全厂不安全报警"></CategoryTitle>
        <TableButtonGroup v-model="activeTab" :list="tabList" @btn-click="tabClick" />
      </div>
      <div class="h-[calc(100%-26px)]" @click="checkAllData">
        <v-chart v-loading="chartLoading" :options="option" autoresize class="w-full h-full"></v-chart>
      </div>
    </div>
    <div class="w-full h-55/100 overflow-hidden mt-10px">
      <div class="flex justify-between">
        <CategoryTitle title="安防报警"></CategoryTitle>
        <div class="flex">
          <TableButtonGroup v-model="securityActiveTab" :list="tabList" @btn-click="securityTabClick" />
          <div class="flex ml-15px items-center cursor-pointer text-white">
            <span class="text-14px" @click="checkAllAlarm">全部报警</span>
            <span
              class="ml-5px text-16px opacity-60"
            >
              <i class="el-icon-d-arrow-right"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between w-full text-white h-45px">
        <div
          v-for="(item, index) in warningNumList"
          :key="index"
          class="flex flex-col justify-around items-center w-31/100 h-full pt-4px"
        >
          <span class="text-14px">{{ item.count }}</span>
          <span class="text-12px">{{ item.name }}</span>
        </div>
      </div>
      <div class="w-full h-[calc(100%-120px)]">
        <el-table
          ref="tableRef"
          height="100%"
          class="mt-4px"
          :data="detailList"
          highlight-current-row
          v-loading="warningLoading"
        >
          <el-table-column label="报警类型" prop="alarmTypeName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="所属建筑" prop="buildingName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="报警时间" prop="identifyTime" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span>{{ row.identifyTime ? dayjs(row.identifyTime).format('YYYY-MM-DD HH:mm:ss') : row.identifyTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="60px">
            <template>
              <span class="cursor-pointer" @click="checkAllAlarm"
                >查看</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          small
          background
          @current-change="getWarningList"
          :current-page.sync="pageInfo.pageNo"
          :page-size.sync="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="pageInfo.total"
          class="text-center"
        ></el-pagination>
      </div>
    </div>
    <AIAlarmListDialog
      v-if="isShowDialog"
      :isShowDialog.sync="isShowDialog"
    ></AIAlarmListDialog>
    <AlarmCenter
      v-if="alarmListVisible"
      :visible.sync="alarmListVisible"
      @alarmJump="alarmJump(arguments)"
    ></AlarmCenter>
  </div>
</template>

<script>
import { includes } from 'lodash'
import { dayjs } from 'dayjs'
import { WisdomSecurityApi, WorkTicketApi } from '@wiz-api/huizhou2'
import { SecurityAlarmRecordApi } from '@wiz-api/security-management'
import { CockpitApi } from '@wiz-api/huizhou2-business'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'
import AIAlarmListDialog from './AIAlarmListDialog'

const AlarmCenter = () => {
  return import('../../tool/AlarmCenter')
}

const wisdomSecurityApi = new WisdomSecurityApi()
const securityAlarmRecordApi = new SecurityAlarmRecordApi()
const cockpitApi = new CockpitApi()

export default {
  components: {
    CategoryTitle,
    TableButtonGroup,
    AIAlarmListDialog,
    AlarmCenter
  },
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      alarmListVisible: false,
      activeTab: '日',
      securityActiveTab: '日',
      tabList: ['日', '月'],
      chartLoading: false,
      isShowDialog: false,
      warningLoading: false,
      rateList: [
        {
          name: '监控设备',
          totalNum: 0,
          onlineNum: 0,
          offLineNum: 0,
          percentage: 0,
        },
        {
          name: '门禁设备',
          totalNum: 0,
          onlineNum: 0,
          offLineNum: 0,
          percentage: 0,
        },
        {
          name: '道闸设备',
          totalNum: 0,
          onlineNum: 0,
          offLineNum: 0,
          percentage: 0,
        },
      ],
      option: {
        color: ['#45F2EB', '#3CD495', '#75C7FF', '#FEFF26'],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          top: 'middle',
          left: '50%',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 15,
          textStyle: {
            color: 'rgba(255, 255, 255, 0.8)',
          },
        },
        series: [
          {
            type: 'pie',
            radius: [0, 60],
            center: ['20%', '50%'],
            data: [],
            label: {
              normal: {
                show: false,
                position: 'inside',
                formatter: '{b}',
                textStyle: {
                  align: 'center',
                  baseline: 'middle',
                  fontSize: 16,
                  fontWeight: '100',
                  color: '#fff',
                },
              },
            },
          },
        ],
      },
      warningNumList: [
        {
          count: 0,
          name: '安防报警总数'
        },
        {
          count: 0,
          name: 'AI视频报警'
        },
        {
          count: 0,
          name: '消防报警'
        }
      ],
      detailList: [],
      pageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getSecurityDeviceStatsReport()
    this.getThreeDimensionalCount()
    this.getAIWarningCount()
    this.getWarningList()
  },
  beforeDestroy() {

  },
  methods: {
    async getSecurityDeviceStatsReport() {
      const [err, res] = await wisdomSecurityApi.getSecurityDeviceStatsReport()
      if (!err && res && res.length) {
        res.forEach((item) => {
          this.rateList.forEach((it) => {
            if (includes(it.name, item.deviceName)) {
              it.totalNum = item.totalCount
              it.onlineNum = item.onLineCount
              it.offLineNum = item.offlineCount
              it.percentage = item.percentage
            }
          })
        })
      }
    },
    // 获取饼状图数据
    async getThreeDimensionalCount() {
      const [err, res] = await cockpitApi.getThreeDimensionalAlarmCount({
        time: this.activeTab === '日' ? 0 : 1
      })
      if (!err && res) {
        this.option.series[0].data = res.map(item => {
          return {
            name: item.key,
            value: item.value
          }
        })
        const data = this.option.series[0].data
        this.option.legend.formatter = (name) => {
          const item = data.filter((it) => {
            return it.name === name
          })[0]
          return `${name} ${item.value}`
        }
      }
    },
    // 获取AI视频报警数量
    async getAIWarningCount() {
      const [err, res] = await securityAlarmRecordApi.getAlarmRecordCount({
        time: this.securityActiveTab === '日' ? 0 : 1
      })
      if (!err) {
        this.warningNumList[1].count = res ?? 0
      }
    },
    // 获取报警列表数据
    async getWarningList() {
      const [err, res] = await securityAlarmRecordApi.getAlarmRecordList({
        time: this.securityActiveTab === '日' ? 0 : 1
      })
      if (!err && res) {
        this.detailList = res.items
        this.pageInfo.total = res.totalCount
      }
    },
    async checkCameraList(name) {
      if (name === '监控设备'){
        this.$emit('transferEvent', {
          toCom: { code: 'CameraList', origin: '', name: '监控列表' },
          type: 'mainComponent',
          props: {},
        })
      } else if (name === '门禁设备') {
        this.$emit('transferEvent', {
          toCom: { code: 'AccessDoorControlGateList', origin: 'SmartSecurity', name: '门禁设备' },
          type: 'mainComponent',
          props: {},
        })
      } else if (name === '道闸设备') {
        this.$emit('transferEvent', {
          toCom: { code: 'AccessControlGateList', origin: 'SmartSecurity', name: '道闸设备' },
          type: 'mainComponent',
          props: {},
        })
      }
      
    },
    // 日月切换
    tabClick(val) {
      this.activeTab = val
      this.getThreeDimensionalCount()
    },
    securityTabClick(val) {
      this.securityActiveTab = val
      this.getAIWarningCount()
      this.getWarningList()
    },
    checkAllAlarm() {
      this.isShowDialog = true
    },
    checkAllData() {
      this.alarmListVisible = true
    }
  },
}
</script>
<style lang="scss" scoped>
.statisticsRate {
  color: #ffffff;
  text-shadow: 0px 0px 13.88px 0px #2f7eff72, 0px 3.08px 6.17px 0px #1da0e999;
  font-family: PangMenZhengDao;
  font-weight: regular;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 0px;
  text-align: center;
}
.statisticsRate {
  .reteItem {
    .one {
      border-radius: 0.9px 0.9px 0px 0px;
      background: #53e0ff66;
      height: 27px;
      line-height: 27px;
    }
    .two {
      border-radius: 0.9px 0.9px 0px 0px;
      background: #59d4a08e;
      height: 27px;
      line-height: 27px;
    }
    .three {
      border-radius: 0.9px 0.9px 0px 0px;
      background: #c3c06c7f;
      height: 27px;
      line-height: 27px;
    }
    .bottomBox {
      border: 1px dotted rgba(255, 255, 255, 0.2);
      padding: 5px;
      .totalBox {
        border-radius: 0.9px;
        background: rgba(40, 163, 202, 0.1);
      }
      .withe07 {
        color: rgba(255, 255, 255, 0.7);
      }
      .onlineCircle {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: rgba(13, 165, 55, 1);
      }
      .offlineCircle {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: rgba(148, 168, 217, 1);
      }
      .rateText {
        bottom: -5px;
        transform: scale(0.8);
      }
    }
  }
}
</style>
